const BabyNameStatuses = {
    'APPROVED': 'approved',
    'PENDING': 'pending',
    'REJECTED': 'rejected'
};

export {
    BabyNameStatuses
};
